import { Route, Routes } from 'react-router-dom';
import ModelManagementPage from './model-management';
import ModelPage from './model-page';

const ModelManagement: React.FC = () => {
  return(
  <Routes>
    <Route path='' element= {<ModelManagementPage/>}/>
    <Route path=':modelId' element={<ModelPage/>}/>
  </Routes>
  )
}

export default ModelManagement